// components/ResizableLoader.jsx
import React, { useState } from "react";
import { Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { CirclesWithBar } from "react-loader-spinner";

const Loader = ({ message = "", loaderSize = 70, fullScreen = true }) => {
  const [size] = useState(loaderSize);
  const theme = useTheme(); // Access MUI theme

  // Use theme color (primary or secondary)
  const loaderColor = theme.palette.primary.main;

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      spacing={2}
      sx={{
        width: fullScreen ? "100vw" : "100%",
        height: fullScreen ? "100vh" : "100%",
        position: fullScreen ? "fixed" : "relative",
        top: 0,
        left: 0,
        zIndex: 9999,
        backgroundColor: fullScreen
          ? theme.palette.mode === "dark"
            ? "rgba(0,0,0,0.4)"
            : "rgba(255,255,255,0.6)"
          : "transparent",
      }}
    >
      <CirclesWithBar
        height={size}
        width={size}
        color={loaderColor}
        outerCircleColor={loaderColor}
        innerCircleColor={loaderColor}
        barColor={loaderColor}
        ariaLabel="circles-with-bar-loading"
        visible={true}
      />
      <Typography
        sx={{
          fontSize: 16,
          fontWeight: 500,
          color: theme.palette.text.primary,
        }}
      >
        {message}
      </Typography>
    </Stack>
  );
};

export default Loader;
